import React from "react";
import {
  Box,
  Grid,
  Typography,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  Link as MuiLink,
} from "@mui/material";
import { Forest } from "@mui/icons-material";
import meetMark  from "../images/about_deb_bg.jpg";

const ProtectingOurEnvironment = () => {
  const isMobile = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <div>
      <Box
        pt={2}
        sx={{
          background: `url(${meetMark })`,
          backgroundSize: "cover",
          height: "100vh",
          minHeight: "fit-content",
        }}
        display="flex"
        flexDirection="column"
        alignItems="center"
      >
        <Grid
          container
          mt={8}
          py={6}
          sx={{width: isMobile ?  "75vw" : "50vw" }}
          display="flex"
          flexDirection="column"
          alignItems="stretch"
        >
          <MuiLink
            href="/priorities"
            underline="none"
            color="white"
            sx={{ mb: 2, fontSize: "1rem" }}
          >
            ← Back to Priorities
          </MuiLink>

          <Grid item display="flex" alignItems="center" gap={2}>
            <Forest sx={{ fontSize: "3rem", color: "white" }} />
            <Typography
              variant="h1"
              sx={{ fontSize: "2.5rem!important", color: "white!important" }}
            >
              Protecting Our Environment
            </Typography>
          </Grid>
        </Grid>

        <Grid
          container
          display="flex"
          justifyContent="center"
          flexDirection="column"
          alignItems="center"
          p={6}
        >
          <Grid item sx={contentBox(isMobile)}>
            <Typography variant="p" color="white">
              As County Executive, Mark will work to protect our open spaces, parks and forests from
              overdevelopment and to combat climate change. People love living in Howard County
              because of its mix of suburban convenience and beautiful natural environment.
              Mark is a reliable advocate for environmental efforts that safeguard residents’ health
              and enjoyment of the outdoors.
            </Typography>
          </Grid>

          <Grid item sx={sectionHeader(isMobile)}>
            <Typography variant="h3" color="white">
              Deb’s Record:
            </Typography>
          </Grid>

          <Grid item sx={contentBox(isMobile)}>
            <List>
              <Bullet text="Sponsored legislation to protect people’s health and safety from big corporations emitting dangerous chemicals in residential neighborhoods." />
              <Bullet text="Overhauled the County’s 10-year growth plan, HoCo By Design, to improve environmental protections." />
              <Bullet text="Led the fight for over 6 years for changes to flight patterns to/from BWI airport that create unhealthy and excessive airplane noise in Howard County neighborhoods." />
              <Bullet text="Supported expansion of solar energy facilities throughout the County. Howard County leads the State in solar siting regulations that promote climate goals." />
              <Bullet text="Voted for a deliberate approach to adopting all-electric standards for new buildings." />
              <Bullet text="Sponsored a bill that required bird-safe building designs to reduce bird strikes on reflective and translucent glass. Howard County is the only jurisdiction in Maryland to have this requirement." />
              <Bullet text="Helped adopt a comprehensive update of the Forest Conservation Act." />
            </List>
          </Grid>
        </Grid>
      </Box>
    </div>
  );
};

const Bullet = ({ text }) => (
  <ListItem disablePadding>
    <ListItemText primary={text} />
  </ListItem>
);

const contentBox = (isMobile) => ({
  fontStyle: "normal",
  fontWeight: "500",
  fontFamily: "'Open Sans', sans-serif",
  fontSize: "16px",
  lineHeight: "1.6875",
  letterSpacing: "0em",
  maxWidth: isMobile ? "auto" : "50vw",
  textAlign: "left",
  mb: 2,
  color: "white!important",
});

const sectionHeader = (isMobile) => ({
  fontWeight: "600",
  fontFamily: "'Open Sans', sans-serif",
  fontSize: "24px",
  lineHeight: "1.6875",
  maxWidth: isMobile ? "auto" : "50vw",
  textAlign: "left",
  mt: 4,
  mb: 4,
});

export default ProtectingOurEnvironment;
